package com.essntl.features.proposal.domain.model

import com.essntl.config.EssntlConfig

val ProposalModel.previewLink get() =
    "${EssntlConfig.essntlBaseUrl}/p/$shareCode?draft=true"

val ProposalModel.shareLink get() =
    "${EssntlConfig.essntlBaseUrl}/p/${shareCode}"

val ProposalModel.historyLink get() =
    "${EssntlConfig.essntlBaseUrl}/p/${shareCode}/v/$version"


enum class ProposalModes(val index: Int) {
    Designer(0),
    Leads(1)
}